<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [formCtrl]="pdvOpsegCtrl"
  [options]="items"
  ctrlTooltip="Izaberite PDV opseg"
  ctrlTooltipPosition="top"
  [ctrlDisabled]="shouldDisable"
></kodit-dropdown>
